import { makeObservable, observable, flow, action } from "mobx";
import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";

export default class BrowseLabelsStore {
  loading = false;
  labels = [];
  query = { search: "", page: 1 };

  constructor(parentStore) {
    makeObservable(this, {
      loading: observable,
      labels: observable,
      query: observable,
      load: flow,
      consume: action,
    });

    this.parentStore = parentStore;
  }

  consume(label) {
    const index = this.labels.findIndex((l) => l.id === label.id);
    if (index !== -1) {
      this.labels.splice(index, 1, label);
      this.labels = [...this.labels];
    }
  }

  *load({ modelId }) {
    if (!modelId) return { success: false };

    try {
      this.loading = true;
      const response = yield api.get(ApiRoutes.forModelLabels(modelId));
      this.labels = response.data?.items ?? [];
      return { success: true, data: response.data };
    } catch (e) {
      return { success: false, error: e };
    } finally {
      this.loading = false;
    }
  }
}
